import { ITaxInfo } from "../../apis/useGetOrderDetail/types";

export const SERVICE_CHARGE_REGEX = /service\s*charge/i;
export const GST_REGEX = /gst/i;

export const findTaxEntry = (tax: ITaxInfo[] | undefined, regex: RegExp): ITaxInfo | undefined =>
	tax?.find((entry) => regex.test(entry.name ?? "") || regex.test(entry.type ?? ""));
